export const INTEGRATION_TYPE_NONE = 'none' as const;
export const INTEGRATION_TYPE_EXCEL = 'excel' as const;
export const INTEGRATION_TYPE_OZON_FBO_PLUS = 'ozon_fbo_plus' as const;
export const INTEGRATION_TYPE_OZON_DELIVERY_FBS = 'ozon_delivery_fbs' as const;
export const INTEGRATION_TYPE_OZON = 'ozon' as const;
export const INTEGRATION_TYPE_1C = '1C' as const;
export const INTEGRATION_TYPE_WILDBERRIES = 'wildberries' as const;
export const INTEGRATION_TYPE_MOYSKLAD = 'moysklad' as const;
export const INTEGRATION_TYPE_YML = 'yml' as const;
export const INTEGRATION_TYPE_YANDEX_MARKET = 'yandex_market' as const;
export const INTEGRATION_TYPE_YANDEX_MARKET_LAAS = 'ya_market_laas' as const;

export const SUPPORTED_INTEGRATION_TYPES = [
    INTEGRATION_TYPE_1C,
    INTEGRATION_TYPE_WILDBERRIES,
    INTEGRATION_TYPE_MOYSKLAD,
    INTEGRATION_TYPE_OZON,
    INTEGRATION_TYPE_OZON_FBO_PLUS,
    INTEGRATION_TYPE_OZON_DELIVERY_FBS,
    INTEGRATION_TYPE_YML,
    INTEGRATION_TYPE_YANDEX_MARKET,
    INTEGRATION_TYPE_YANDEX_MARKET_LAAS,
] as const;

export const SUPPORTED_INTEGRATION_SUBTYPES = [
    INTEGRATION_TYPE_OZON_FBO_PLUS,
    INTEGRATION_TYPE_OZON_DELIVERY_FBS,
    INTEGRATION_TYPE_YANDEX_MARKET_LAAS,
] as const;

/**
 * Список возможных фичей для источника
 */
// Блок "сопоставление характеристик"
export const INTEGRATION_SETTINGS_FEATURE_MAPPED_CHARACTERISTICS = 'mapped_characteristics' as const;
// Блок "сопоставление веса и габаритов"
export const INTEGRATION_SETTINGS_FEATURE_MAPPED_SIZES_CHARACTERISTICS = 'mapped_sizes_characteristics' as const;
// Блок "сопоставлять цены по"
export const INTEGRATION_SETTINGS_FEATURE_COMPARE_PRICES_MAPPING = 'compare_prices_mapping' as const;
// Блок "сохранять изменения из"
export const INTEGRATION_SETTINGS_FEATURE_SAVE_CHANGES_FROM = 'save_changes_from' as const;
// Блок "объединять в варианты как в"
export const INTEGRATION_SETTINGS_FEATURE_MERGE_VARIANTS_AS_IN = 'merge_variants_as_in' as const;
// Блок "периодическое обновление"
export const INTEGRATION_SETTINGS_FEATURE_REGULAR_UPDATES = 'regular_updates' as const;
// Блок "периодическое обновление" с подтверждающим модальным окном
export const INTEGRATION_SETTINGS_FEATURE_REGULAR_UPDATES_WITH_CONFIRMATION =
    'regular_updates_with_confirmation' as const;
// Блок "периодическое обновление" для просмотра, без возможности редактирования
export const INTEGRATION_SETTINGS_FEATURE_REGULAR_UPDATES_VIEW = 'regular_updates_view' as const;
// Блок "периодическое обновление" для дополнительной интеграции
export const INTEGRATION_SETTINGS_FEATURE_REGULAR_UPDATES_SUBTYPE = 'regular_updates_subtype' as const;
// Блок с выбором настроек обновления "категории"
export const INTEGRATION_SETTINGS_FEATURE_CATEGORIES_UPDATE_SETTINGS = 'categories_update_settings' as const;
// Блок с выбором категорий, из которых осуществлять загрузку
export const INTEGRATION_SETTINGS_FEATURE_CATEGORIES_WHICH_TO_UPLOAD = 'categories_which_to_upload' as const;
// Блок с выбором доступных складов
export const INTEGRATION_SETTINGS_FEATURE_WAREHOUSES = 'warehouses' as const;
// Блок складов для дополнительной интеграции
export const INTEGRATION_SETTINGS_FEATURE_WAREHOUSES_SUBTYPE = 'warehouses_subtype' as const;
// Блок с выбором настроек отправки информации заказов в МойСклад, используется только в блоке с заказами при интеграции остатков с МойСклад
export const INTEGRATION_SETTINGS_FEATURE_SEND_ORDERS_INTO_MOYSKLAD = 'send_orders_into_moysklad' as const;
// Блок с выбором договора комиссии Ozon.Доставка в блоке с заказами при интеграции остатков с МойСклад и добавленным соисточником Ozon.Доставка
export const INTEGRATION_SETTINGS_FEATURE_COMMISSIONER_CONTRACTS = 'commissioner_contracts' as const;
// Блок с указанием источника данных с возможностью его изменить
export const INTEGRATION_SETTINGS_FEATURE_DATA_SOURCE = 'data_source' as const;
// Блок с указанием источника данных без возможности его изменить
export const INTEGRATION_SETTINGS_FEATURE_DATA_SOURCE_READONLY = 'data_source_readonly' as const;
// Блок с указанием источника данных для дополнительной интеграции с возможностью его изменить
export const INTEGRATION_SETTINGS_FEATURE_DATA_SOURCE_SUBTYPE = 'data_source_subtype' as const;
// Блок с выбором настроек обновления групп характеристик
export const INTEGRATION_SETTINGS_FEATURE_CHARACTERISTICS_GROUPS_UPDATE_SETTINGS =
    'characteristics_groups_update_settings' as const;
// Блок с выбором действий с новыми товарами
export const INTEGRATION_SETTINGS_FEATURE_ACTIONS_WITH_NEW_PRODUCTS = 'actions_with_new_products' as const;
// Блок с выбором магазина Яндекс Маркета для передачи ставки НДС
export const INTEGRATION_SETTINGS_FEATURE_YANDEX_MARKET_CAMPAIGN = 'yandex_market_campaign' as const;
// Блок с выбором способа сопоставления
export const INTEGRATION_SETTINGS_FEATURE_COMPARE_PRODUCTS_BY = 'compare_products_by' as const;

export const INTEGRATION_SETTINGS_FEATURES = [
    INTEGRATION_SETTINGS_FEATURE_MAPPED_CHARACTERISTICS,
    INTEGRATION_SETTINGS_FEATURE_MAPPED_SIZES_CHARACTERISTICS,
    INTEGRATION_SETTINGS_FEATURE_COMPARE_PRICES_MAPPING,
    INTEGRATION_SETTINGS_FEATURE_SAVE_CHANGES_FROM,
    INTEGRATION_SETTINGS_FEATURE_COMPARE_PRODUCTS_BY,
    INTEGRATION_SETTINGS_FEATURE_MERGE_VARIANTS_AS_IN,
    INTEGRATION_SETTINGS_FEATURE_REGULAR_UPDATES,
    INTEGRATION_SETTINGS_FEATURE_REGULAR_UPDATES_WITH_CONFIRMATION,
    INTEGRATION_SETTINGS_FEATURE_REGULAR_UPDATES_VIEW,
    INTEGRATION_SETTINGS_FEATURE_REGULAR_UPDATES_SUBTYPE,
    INTEGRATION_SETTINGS_FEATURE_CATEGORIES_UPDATE_SETTINGS,
    INTEGRATION_SETTINGS_FEATURE_CATEGORIES_WHICH_TO_UPLOAD,
    INTEGRATION_SETTINGS_FEATURE_WAREHOUSES,
    INTEGRATION_SETTINGS_FEATURE_WAREHOUSES_SUBTYPE,
    INTEGRATION_SETTINGS_FEATURE_SEND_ORDERS_INTO_MOYSKLAD,
    INTEGRATION_SETTINGS_FEATURE_COMMISSIONER_CONTRACTS,
    INTEGRATION_SETTINGS_FEATURE_DATA_SOURCE,
    INTEGRATION_SETTINGS_FEATURE_DATA_SOURCE_SUBTYPE,
    INTEGRATION_SETTINGS_FEATURE_CHARACTERISTICS_GROUPS_UPDATE_SETTINGS,
    INTEGRATION_SETTINGS_FEATURE_YANDEX_MARKET_CAMPAIGN,
    INTEGRATION_SETTINGS_FEATURE_ACTIONS_WITH_NEW_PRODUCTS,
    INTEGRATION_SETTINGS_FEATURE_DATA_SOURCE_READONLY,
] as const;

export const DO_NOT_COMPARE_VALUE_AS_DEFAULT = 'do_not_compare_value' as const;
export const DO_NOT_COMPARE_TEXT_AS_DEFAULT = 'Не сопоставлять' as const;

export const INTEGRATION_MAPPING_STATIC_ITEMS = [
    { value: 'name', content: 'Название', scopeArea: 'property' },
    { value: 'seller_sku', content: 'Артикул', scopeArea: 'property' },
    { value: 'barcode', content: 'Штрихкод', scopeArea: 'property' },
] as const;
